import {useEffect, useState} from 'react';
import {UploadsProvider, initializeUploadsProvider} from 'mars-uploader';
import {getLocale, isNonProd, getAccountId, getActualUser} from './util/ApiConfig';
import Locale from './util/Locale';
import NavTreeProvider from './Providers/NavTreeProvider';
import MediaLibraryController from './controllers/MediaLibraryController';
import Analytics from './util/Analytics';
import Util from './util/Util';
import setupUserInfo from './util/userInfo';
import AssetsProvider from './Providers/AssetsProvider';
import './App.scss';

initializeUploadsProvider(
    {
        getAccountId,
        getUserId: getActualUser,
        createUID: Util.createUID,
        loggedOutCheck: Util.loggedOutCheck,
        dataURLtoFile: Util.dataURLtoFile,
        initInventoryFolderId: Util.setUploaderLibraryId,
        getInventoryFolderId: Util.getUploaderLibraryId,
        getURLparameter: Util.getSingleURLparameter
    },
    {
        allowCMYK: false,
        maxImageWidth: 5000, // 5000px wide
        maxImageSize: 20 * 1024 * 1024, // 20MB for images
        maxPdfSize: 20 * 1024 * 1024, // 20MB for PDFs
        maxVideoTime: 5 * 60, // up to 5 minutes
        maxVideoSize: 200 * 1024 * 1024 // 200GB for videos
    }
);

export default function App() {
    const [locale, setLocale] = useState('en-US');

    useEffect(() => {
        // Turn Google Analytics on when on prod (live) or with set url parameter ga=true
        if (process.env.NODE_ENV !== 'test') {
            if (!isNonProd() || Util.getBooleansFromUrlSearchParams(['ga'])[0]) {
                Analytics.initialize('UA-68704255-1', true);
            }
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const newLocale = getLocale();

        if (locale !== newLocale) {
            Locale.change(newLocale);
            setLocale(newLocale);
        }
    }, [locale]);

    useEffect(() => {
        const jwt = Util.getURLparameter('__jwt_session');
        if (jwt) {
            fetch(window.location.href?.replace('promotions', 'welcome')?.replace('medialibrary3', ''));
            // Allow time for welcome to set JWTAuth cookie before redirecting
            setTimeout(() => {
                window.location.href = Util.buildUrlWithoutParameter('__jwt_session');
            }, 2000);
        }
    }, []);

    const [isUserInfoReady, setUserInfoReady] = useState(false);

    useEffect(() => {
        const getUserInfo = async () => {
            try {
                await setupUserInfo();
                setUserInfoReady(true);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('getUserInfo failed', error);
            }
        };
        getUserInfo();
    }, []);

    if (!isUserInfoReady) {
        return (
            <div className="outer-page-loading">
                <div className="page-loading" />
            </div>
        );
    }
    return (
        <UploadsProvider>
            <NavTreeProvider>
                <AssetsProvider>
                    <MediaLibraryController />
                </AssetsProvider>
            </NavTreeProvider>
        </UploadsProvider>
    );
}
